<script>
  import DimensionLine from "./DimensionLine.svelte"

  export let dimensions
  export let glyph

  let height
</script>

<div class="root" style="--height: {height}px;">
  <div class="wrapper" bind:clientHeight={height}>
    <div class="glyph">
      {glyph.character}
      <div class="lines">
        {#each dimensions.lines as { name, value, position }}
          <DimensionLine {name} {value} {position} />
        {/each}
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  @use "../../partials";

  .root {
    --glyph-font-size: var(--height);
    --glyph-line-height: normal;
  }

  .wrapper {
    position: relative;
    height: 100%;
  }

  .glyph {
    font-family: var(--family);
    font-size: var(--glyph-font-size);
    line-height: var(--glyph-line-height);

    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
  }

  .lines {
    position: absolute;
    inset: 0;
  }
</style>
